const FriendlyCaptchaMixin = {
  data() {
    return {
      isCaptchaCompleted: false,
      captchaToken: '',
      resetCaptcha: () => {}
    }
  },
  methods: {
    onFriendlyCaptchaCompleted(event) {
      this.isCaptchaCompleted = true
      this.captchaToken = event?.detail?.response || ''
    },
    onFriendlyCaptchaError() {
      this.cleanCaptchaValues()
    },
    onFriendlyCaptchaExpire() {
      this.cleanCaptchaValues()
    },
    onFriendlyCaptchaReset () {
      this.cleanCaptchaValues()
    },
    onSetResetAction(reset) {
      this.resetCaptcha = reset
    },
    cleanCaptchaValues() {
      this.isCaptchaCompleted = false
      this.captchaToken = ''
    },
    onResetCaptcha() {
      this.resetCaptcha()
    }
  }
}

export default FriendlyCaptchaMixin
